"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getException;

var _fluxStandardAction = require("flux-standard-action");

/**
 * Returns the error, if present, on an FSA
 *
 * @param {Object} action - an FSA - flux standard action
 */
function getException(action) {
  if ((0, _fluxStandardAction.isFSA)(action) && (0, _fluxStandardAction.isError)(action)) {
    return action.payload;
  }

  return undefined;
}